<template>
  <div class="content" :style="look?'background: #ffffff;':''">
    <div class="list" v-if="view">
      <article class="left-middle-right self" v-if="!look&&items.myRank !='0'">
        <div class="left">
          <span class="selfStyle"></span>
        </div>
        <div class="middle" style="align-items: baseline;">
            <span style="font-size:0.3rem;padding-left:0.2rem;">当前名次</span>
            <span style="font-size:0.28rem;padding-left:0.2rem;">第<i>&nbsp;{{items.myRank}}&nbsp;</i>名</span>
        </div>
        <div class="right">
            <span style="font-size:0.3rem;padding-right:0.2rem;font-weight: 100;">已销售</span>
            <span style="font-size:0.32rem;font-weight: bold;">¥ {{items.myOrderAmount}}</span>
        </div>
      </article>
      <article v-if="rank!==undefined && rank.length > 0" :style="!look?'margin-top:.2rem;margin-bottom:60px;':''">
        <van-list v-model="loading" :finished="finished" :finished-text="finishedText" :immediate-check="check" @load="onLoad">
        <div class="left-middle-right" v-for="(item,index) in rank" :key="index" :style="look == 'detail'?'margin-top:0;':''" :class="item.rank == items.myRank?'active':''">
          <div class="left">
            <span :class="index=='0'? 'oneStyle':index == '1'?'twoStyle':index == '2'?'threeStyle':''"></span>
            <span v-if="index > '2'" class="num" :style="item.rank == items.myRank?'color:#fa6400':''">{{item.rank}}</span>
          </div>
          <div class="middle">
            <img :src="item.headUrl" class="head" />
            <span class="name">{{item.nickName | ellipsis}}</span>
          </div>
          <div class="right">¥ {{item.orderAmount}}</div>
       </div>
       </van-list>
      </article>
      <div v-if="rank.length == undefined || rank.length <= 0">
        <div class="no-data">
            <img src="../img/no-data.png">
            <p>当前还没有排名哦~</p>
        </div>
      </div>
      <div class="more" @click="more" v-if="moreBtnShow">
        全部业绩排名&nbsp;<van-icon name="arrow" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pkList",
  props: {
    show:String,
    id:String
  },
  data() {
    return {
      view: true,
      page:{
          "taskId": "",
          "page": "1",
          "limit": "15"
      },
      loading: false,
      finished: false,
      check:false,
      finishedText:"没有更多了",
      moreBtnShow:false,
      items: {},
      rank:[],
      look:"",
      channelType:""
    };
  },
  created() {
    this.look = this.show
    if (this.$route.query.id) {
      this.page.taskId = this.$route.query.id;
      this.myPkRank();
    }
    this.channelType = JSON.parse(sessionStorage.getItem("user")).channelType;
    if(this.channelType == 'app') UnionDrugHealthy.hiddenShareIcon()
  },
  methods: {
    myPkRank(){
        this.$api.taskMyPkRank({taskId:this.page.taskId}).then(res => {
          if(res.errno == '0'){
            this.items = res.data;
            this.getData()
          }
        })
    },
    getData() {
        this.$api.taskPkRank(this.page).then(res => {
          if(res.errno == '0'){
            this.rank = this.rank.concat(res.data.body);
            this.view = true
            this.loading = false
            // 数据全部加载完成
            if (res.data.body.length < 10) {
              this.finished = true;
            }
            if(this.rank.length>3&&this.look) this.moreBtnShow = true
            const take = (arr, n = 1) => arr.slice(0, n);
            if(this.look){
                this.rank = take(this.rank, 3)
                this.finishedText = ""
                this.finished = true;
                this.$emit('dateFn',this.items,res.data.body.length)
            }
          }
        });
    },
    onLoad() {
      this.page.page++;
      this.getData();
    },
    more() {
      this.$emit('funVaule')
    }
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 8) {
        return value.slice(0,8)+'...';
      }
      return value;
    }
  }
};
</script>

<style scoped lang="scss">
.content {
  background: #F8F8F8;
  width: 100%;
  // overflow-y: scroll;
  .list {
    // background: #fff;
    .self{
        // margin-bottom: 0.3rem;
    }
    .active {
      background: rgba(255, 250, 250, 1) !important;
      color: #fa6400 !important;
    }
    .left-middle-right {
      display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
      display: -moz-box; /* 老版本语法: Firefox (buggy) */
      display: -ms-flexbox; /* 混合版本语法: IE 10 */
      display: -webkit-flex; /* 新版本语法: Chrome 21+ */
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.24rem;
      color: #333;
      padding: 0 0.3rem;
      background: #fff;
      .left,
      .middle,
      .right {
        padding: 0.4rem 0;
      }
      .left {
        text-align: left;
        display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
        display: -moz-box; /* 老版本语法: Firefox (buggy) */
        display: -ms-flexbox; /* 混合版本语法: IE 10 */
        display: -webkit-flex; /* 新版本语法: Chrome 21+ */
        display: flex;
        align-items: center;
        .num{
            font-size: 0.32rem;
            color: rgb(97, 97, 97);
            text-align: center;
        }
      }
      .middle {
        flex: 1;
        background: none;
        display: flex;
        align-items: center;
        .head {
          width: 80px;
          height: 80px;
          margin-left: 0.2rem;
          border-radius: 50%;
        }
        .name {
          font-size: 0.32rem;
          padding-left: 0.3rem;
        }
        i{
          color:#DD2B1E;
          font-style: normal;
        }
      }
      .right {
        font-size: 0.32rem;
        text-align: right;
        font-weight: bold;
      }
    }
    .no-data{
        color: #999;
        background: #fff;
        font-size: 0.24rem;
        // padding: 0.6rem 0 0;
        text-align: center;
        img{
            width: 2.7rem;
        }
        p{
            padding-top: 0.3rem;
        }
    }
    .more{
        color:#888;
        background: #fff;
        font-size: 0.28rem;
        text-align: center;
        padding:0.3rem 0 0;
        margin: 0 0.3rem;
        border-top: 1px solid #eee;
        display: flex;
        align-items: center;
        justify-content: center;
    }
  }
}
.oneStyle,
.twoStyle,
.threeStyle,.num {
  width: 50px;
  height: 50px;
}
.oneStyle {
  background: url("../img/one.png") center no-repeat !important;
  background-size: 100% 100% !important;
}
.twoStyle {
  background: url("../img/two.png") center no-repeat !important;
  background-size: 100% 100% !important;
}
.threeStyle {
  background: url("../img/three.png") center no-repeat !important;
  background-size: 100% 100% !important;
}
.selfStyle {
  width: 36px;
  height: 36px;
  background: url("../img/self.png") center no-repeat !important;
  background-size: 100% 100% !important;
}
img {
  vertical-align: middle;
}
</style>
